// First-party funnel events for the public site. No third-party script:
// a keepalive POST to /site/events, which writes `siteEvents/{id}`. One
// anonymous session id per tab so a click and the signup it led to can
// be joined. Fails silently — a blocked call must never break a CTA.
// Not navigator.sendBeacon: it always sends credentials, and the API's
// CORS answer has no Allow-Credentials, so the browser dropped it.
import { API_BASE } from '../data/env';

const KEY = 'nv-sid';

function sid() {
  try {
    let v = sessionStorage.getItem(KEY);
    if (!v) {
      v = Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
      sessionStorage.setItem(KEY, v);
    }
    return v;
  } catch {
    return 'none';
  }
}

export function track(name, props = {}) {
  if (!API_BASE || typeof navigator === 'undefined' || navigator.webdriver) return;
  try {
    const body = JSON.stringify({
      name: String(name).slice(0, 40),
      props,
      sid: sid(),
      path: window.location.pathname,
      ref: document.referrer ? new URL(document.referrer).hostname : '',
      w: window.innerWidth,
    });
    fetch(`${API_BASE}/site/events`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
      credentials: 'omit',
    }).catch(() => {});
  } catch { /* ignore */ }
}
